// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__YbOPk","subTitle":"Menu_subTitle__G7cMX","subtitleIcon":"Menu_subtitleIcon__9jm62","link":"Menu_link__TK-Ij","menu":"Menu_menu__1ydC2"};